import { render, staticRenderFns } from "./Ltitle.vue?vue&type=template&id=53a5e452&scoped=true&"
import script from "./Ltitle.vue?vue&type=script&lang=js&"
export * from "./Ltitle.vue?vue&type=script&lang=js&"
import style0 from "./Ltitle.vue?vue&type=style&index=0&id=53a5e452&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a5e452",
  null
  
)

export default component.exports